import { makeStyles } from "@material-ui/core/styles";

export default makeStyles({
  noContent: {
    padding: "0 24px",
    width: "100%",
    height: "100%",
    maxHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: 16,
    wordBreak: "break-word"
  }
});
